import { render, staticRenderFns } from "./ClassificationHeader.vue?vue&type=template&id=6ddde3e5&scoped=true&"
import script from "./ClassificationHeader.vue?vue&type=script&lang=js&"
export * from "./ClassificationHeader.vue?vue&type=script&lang=js&"
import style0 from "./ClassificationHeader.vue?vue&type=style&index=0&id=6ddde3e5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddde3e5",
  null
  
)

export default component.exports